export default {
  title: 'Last 4 weeks',
  item_interval: '(1)[Visit 1 time];(2)[Visit 2 times];(3-5)[Visit 3-5 times];(6-inf)[Visit 6+ times];',
  total: 'Total Visitors',
};
